import moment from 'moment'

export function createAssignmentList(assignments) {

    let list = []

    assignments.forEach(assignment => {

        list.push({
            id: parseInt(assignment.id, 10),
            startTime: `${assignment.startTime}:00`,
            endTime: `${assignment.endTime}:00`,
            signature: assignment.signature,
            safetyAcknowledgment: assignment.safetyAcknowledgment,
        })
    })

    return list
}

export function calculateTotalManHours(assignments) {
    let totalHours = 0

    assignments.forEach(assignment => {
        const startTime = moment(`1/1/2023 ${assignment.startTime}:00`)
        const endTime = moment(`1/1/2023 ${assignment.endTime}:00`)

        const duration = endTime.diff(startTime, "hours", true)

        totalHours += duration
    })

    return totalHours.toFixed(1)
}